(function($){

	/* Get accurate Viewport sizing (no jQuery) */
    var viewportwidth;
    var viewportheight;

    function getWindowSize(){
        if (typeof window.innerWidth != 'undefined'){
            viewportwidth = window.innerWidth,
            viewportheight = window.innerHeight
        }else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
            viewportwidth = document.documentElement.clientWidth,
            viewportheight = document.documentElement.clientHeight
        }else{
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
            viewportheight = document.getElementsByTagName('body')[0].clientHeight
        }
    }
    
    function search_MM_findObj(n, d) { //v4.01
        var p,i,x;
        if(!d) d=document;
        if((p=n.indexOf("?"))>0&&parent.frames.length) {d=parent.frames[n.substring(p+1)].document; n=n.substring(0,p);}
        if(!(x=d[n])&&d.all) x=d.all[n];
        for (i=0;!x&&i<d.forms.length;i++) x=d.forms[i][n];
        for(i=0;!x&&d.layers&&i<d.layers.length;i++) x=MM_findObj(n,d.layers[i].document);
        if(!x && d.getElementById) x=d.getElementById(n);
        return x;
    }

    function searchsite()
    {
        var el = document.getElementById( "searchform" );
        el.submit();
    }
    
    function initSlider() {
        $('.slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
    }

    /*
     *
     * Equal Height jQuery Snippet.  Using this for footer and grid accordion
     *
     */
    var equalheight = function (container){

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = [],
            $el,
            topPosition = 0,
            currentDiv;
    
        $(container).each(function () {

            $el = $(this);
            $el.height('auto');
            topPosition = $el.position().top;

            if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs = [];
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            }
            else {
                rowDivs.push($el);
                currentTallest = Math.max(currentTallest, $el.height());
            }
        });
        
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].css('height', currentTallest);
        }
    };
    

	/* Document Ready */
	$(document).ready(function() {
		getWindowSize();
        equalheight('.vertical_center');

        initSlider();
        

        // Configure/customize these variables.
        var showChar = 140;  // How many characters are shown by default
        var ellipsestext = "...";
        var moretext = "More Details";
        var lesstext = "Show Less";

        $('.additional-options .content').each(function() {
            var content = $(this).html();

            if(content.length > showChar) {

                var c = content.substr(0, showChar);
                var h = content.substr(showChar, content.length - showChar);

                var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" aria-label="Toggle more text" class="toggle-more">' + moretext + '</a></span>';

                $(this).html(html);
            }

        });

        $(".toggle-more").click(function(){
            if($(this).hasClass("less")) {
                $(this).removeClass("less");
                $(this).html(moretext);
            } else {
                $(this).addClass("less");
                $(this).html(lesstext);
            }
            $(this).parent().prev().toggle();
            $(this).prev().toggle();
            return false;
        });

        
        //Sidr
        $('#mobile-trigger').sidr({
            name: 'sidr',
            side: 'right',
            displace: false,
            onOpen: function() {
                $('#mobile-trigger').addClass('active');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
            },
            onOpenEnd: function(){
                $( 'body' ).css({
                    "position": "fixed",
                    "left": "0",
                    "top": "0",
                    "width": "100%"
                });
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
                $('#mobile-trigger').removeClass('active');  
            },
            onCloseEnd: function(){
                $( 'body' ).css({
                    "position": "relative",
                    "left": "auto",
                    "top": "auto",
                    "width": "100%"
                });
            },
            source : function() {
                $(this).addClass('active');
                return '<div id="mobile-menu"><span class="sidr__close">Close Menu &times;</span><div class="sidr__inner">' + $('#main-navigation').html() + '</div><div class="sidr__search"><div class="header-search--form"><form id="searchform" method="get" action="/search/"><div id="sidr_form" class="sr-only">Search the site</div><input type="text" name="q" aria-labelledby="sidr_form" class="search-input" role="search"><button onclick="javascript:searchsite();" runat="server" class="button button-submit">Search</button></form></div></div><div class="sidr__social">' + $('.site-header__subscribe').html() + '</div></div>';
            }
        });
        
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });
        
        $('.has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
//            $(this).parent().find('.sub-menu').slideToggle();
            $(this).siblings('.sub-menu').slideToggle();
        });
        
        $('.toggle_sidebar').click(function(e) {
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.has-children.is-open').each(function() {
            $(this).find('.arrow').addClass('active');
            $(this).find('.sub-menu').show();
        });
        
        
        $('.header-search--title').click(function(e) {
            e.preventDefault();
            $('.header-search--form').toggleClass('active');
        });

	});

	$(window).on("resize", function() {
		getWindowSize();
        equalheight('.vertical_center');
	});

})(jQuery);